import {store} from "../redux/store";
import {setGalleryPage} from "../redux/actions/setGalleryPage";
import {getGalleryPage} from "../action/getGalleryPage";

export const galleryLoader = async (args) => {
    store.dispatch(setGalleryPage(await getGalleryPage(args.params.id)));
    return true
}
